export default "__VITE_ASSET__C_cbkStx__"